import { Button } from "../../ui/button";
import { useLoteProgress } from "./LoteProgressContext";

function EnvioLoteSection({
  mostrarBotaoNovo = false,
  linkNovo = "/filiado/emplacar/novo",
}) {
  const {
    abrirModalLote,
    abrirPainelLote,
    enviandoLote,
    progressoPercentual,
  } = useLoteProgress();
  const percentualNormalizado = Number.isFinite(progressoPercentual)
    ? Math.max(0, Math.min(100, Math.round(progressoPercentual)))
    : 0;

  return (
    <div className="row row-padding-conteudo">
      <div className="col-12 d-flex flex-wrap justify-content-end align-items-center gap-3">
        <Button
          type="button"
          onClick={abrirPainelLote}
          className="tw-min-w-[150px] btn-progress"
          style={{ "--progress-fill": `${percentualNormalizado}%` }}
        >
          <span className="btn-progress__label">Progresso</span>
          <span className="btn-progress__percent">{percentualNormalizado}%</span>
        </Button>
        <Button
          type="button"
          onClick={abrirModalLote}
          disabled={enviandoLote}
          className="tw-min-w-[150px] btn-progress"
          style={{ "--progress-fill": `${percentualNormalizado}%` }}
        >
          <span className="btn-progress__label">Envio em lote</span>
        </Button>
      
        {mostrarBotaoNovo && (
          <Button asChild className="tw-min-w-[120px] tw-gap-2">
            <a href={linkNovo}>
              <span className="material-symbols-outlined tw-text-base" aria-hidden="true">
                add_circle
              </span>
              Novo
            </a>
          </Button>
        )}
      </div>
    </div>
  );
}

export default EnvioLoteSection;
